<customer-select class="mx:hidden sm:block sm:w-full"></customer-select>
<div class="contract__container sm:px-4 mx:px-8">
    <div class="contract-history__tabs">
        <nz-tabset [(nzSelectedIndex)]="tabSelectedIndex"  [nzTabBarExtraContent]="extraTemplate">
            <nz-tab [nzTitle]="'CONTRACT_DETAIL'| translate" *ngIf="hasPermission('ContractDetails')">
              <ng-template nz-tab>
              <app-contract [tabSelectedIndex]="tabSelectedIndex"></app-contract>
              </ng-template>
            </nz-tab>
            <nz-tab  [nzTitle]="'REBATE_DETAIL'| translate" *ngIf="hasPermission('RebateDetails')">
              <ng-template nz-tab>
                <app-rebate [tabSelectedIndex]="tabSelectedIndex"></app-rebate>
            </ng-template>
            </nz-tab>
        </nz-tabset>
        <ng-template #extraTemplate>
          <customer-select class="sm:hidden mx:block"></customer-select>
          </ng-template>
    </div>
</div>
